import { render, staticRenderFns } from "./courseresults.vue?vue&type=template&id=754a1a68&scoped=true"
import script from "./courseresults.vue?vue&type=script&lang=js"
export * from "./courseresults.vue?vue&type=script&lang=js"
import style0 from "./courseresults.vue?vue&type=style&index=0&id=754a1a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a1a68",
  null
  
)

export default component.exports